import { ArpAccess, InternalArpMetadata } from '../arpMedia'
import { BaseModel } from './common'
import { MintExtras } from './MintExtras'
import { TokenGate } from './TokenGate'
import { User } from './User'

export enum ArpMediaType {
  SONG = 'song',
  SAMPLE = 'sample',
  STEM = 'stem'
}

/** Filterable types for Explore page. Separates stems into sub-categories. */
export enum ArpMediaSubType {
  ////// Stem subtypes //////
  // User uploaded clips of arbitrary length
  CLIP = 'clip',
  // Instrument stems made in arpeggi studio.
  MIDI_INSTRUMENT = 'midi-instrument',
  // Drum stems made in arpeggi studio.
  MIDI_DRUM = 'midi-drum',
  // Audio stems made in arpeggi studio. These are usually not shown.
  AUDIO = 'audio'
}

export interface ArpMedia extends BaseModel {
  mintedAt: string
  type: ArpMediaType
  contractAddress: string
  tokenId: number
  metadata: InternalArpMetadata
  version: number
  dataUri: string
  cachedMp3DataUri: string | null
  cachedWavDataUri: string | null
  instrument: string
  userId: number
  user: User
  isFeatured?: boolean
  subComponents?: ArpMedia[]
  favoriteCount?: number
  remixCount: number
  isBlocklist: boolean
  isDefaultSample: boolean
  durationMs: number
  playCount: number
  mintExtras?: MintExtras
  access?: ArpAccess
  tokenGate?: TokenGate
  samplePackTitle?: string
}

export enum ArpMediaParts {
  SUB_COMPONENTS = 'subComponents',
  FAVORITE_COUNT = 'favoriteCount'
}

export interface ArpMediaStatistics {
  mintedSongCount: number
  mintedStemCount: number
  mintedSampleCount: number
}
